//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditableTaskName from './editable-task-name.vue';
import FormattedTaskName from './formatted-task-name.vue';
import ElementsPreview from './elements-preview.vue';
import ActionMenu from './action-menu.vue';
import DateMenuContent from './date-menu-content.vue';
import CardAttachingZones from './card-attaching-zones.vue';
import SquareButton from './square-button.vue';
import {defaultListID} from '../reactive-cache.js';
import {
  toggleDoneness,
  archiveItems,
} from '../db-utils.js';
import {
  calcItemColor,
} from '../utils.js';
import moment from 'moment';
import {
  isoDateFormat,
  formatDateChip,
} from '../time-utils.js';
import {taskCardsMap} from '../component-registers.js'
import { getReversedAncestors } from '../ordered-relation';

export default {
  props: [
    'task',
    'parentcolor',
    'virtualized',
  ],
  data() {
    const now = moment();
    return {
      showcontents: !this.virtualized,
      todayIso: now.clone().startOf('day').format(isoDateFormat),
      thisWeekIso: now.clone().startOf('isoWeek').format(isoDateFormat),
      hoverActive: false,
      dragInElements: false,
      menuOpen: false,
      dateMenu: false,
      isMobile: (('ontouchstart' in window) ||
                 (window.navigator.msMaxTouchPoints > 0)),
    };
  },
  components: {
    ElementsPreview,
    EditableTaskName,
    FormattedTaskName,
    ActionMenu,
    DateMenuContent,
    CardAttachingZones,
    SquareButton,
  },
  methods: {
    toggleSelected() {
      if (this.$taskCardsController.selectedTasksIds &&
          this.task._id in this.$taskCardsController.selectedTasksIds) {
        this.$taskCardsController.unselect(this.task)
      } else {
        this.$taskCardsController.select(this.task)
      }
    },
    onCardClick(event) {
      this.$taskCardsController.handleClickedCard(this.task, event)
    },
    toggleDone() {
      if (this.localSpecialState) return;
      toggleDoneness(this.task, this);
    },
    archive() {
      archiveItems([this.task], this);
    },
    async openParent() {
      this.$taskCardsController.leaveSpecialState();
      const url = this.task.subtaskOf.parentClass === 'list'
        ? `/lists/${this.task.subtaskOf.parentKey}`
        : `/task/${this.task.subtaskOf.parentKey}`
      this.$router.push(url);
    },
    async addElementInTaskView(type) {
      this.$taskCardsController.leaveSpecialState();
      this.$router.push(`/task/${this.task._id}?add_element=${type}`);
    },
    getInitials(name) {
      const teamSettings = this.$reactiveCache.metadata[this.task.couch.name]?.settings
      if (teamSettings?.initials && teamSettings?.initials[name]) {
        return teamSettings?.initials[name]
      }
      // Include digits, as some usernames may differ only by number
      const initials = name.split(/[^a-z0-9]/i).map(word => word[0]).join('')
      return initials.toUpperCase().substring(0, 2);
    },
    inSpecialState() {
      return this.localSpecialState || this.$root.pendingDrag;
    },
    onPointerEnter(event) {
      if (event.pointerType === 'touch') {
        // Not a real hover.
        return;
      }
      this.hoverActive = true;
      if (!this.inSpecialState() && this.$refs.hoverButtons) {
        this.$refs.hoverButtons.style.display = 'flex';
      }
      if (this.$refs.elementsPreview) {
        this.$refs.elementsPreview.setDropZoneHighlight(true);
      }
    },
    onPointerLeave(event) {
      if (event.pointerType === 'touch') {
        // Not a real hover.
        return;
      }
      this.hoverActive = false;
      if (this.$refs.hoverButtons) {
        this.$refs.hoverButtons.style.display = 'none';
      }
      if (this.$refs.elementsPreview) {
        this.$refs.elementsPreview.setDropZoneHighlight(false);
      }
    },
  },
  computed: {
    isDone() {
      return !!this.task.doneAtTimestampMs;
    },
    itemIcon() {
      switch (this.task.type) {
        case "task": return this.isDone ? 'check_box' : 'check_box_outline_blank'
        case "goal": return this.isDone ? 'flag' : 'outlined_flag'
        case "event": return 'event'
      }
    },
    elements() {
      return this.task.getChildren();
    },
    elementCount() {
      return this.elements.length;
    },
    isGoal() {
      return this.task.type === "goal"
    },
    isShared() {
      return this.task.couch.collaborators.length > 1
    },
    showMembers() {
      return this.task.couch.collaborators.length > 1 && (this.task.assignees || this.parentMembers.length)
    },
    goalHint() {
      return !!this.task.doneAtTimestampMs
        ? this.$gettext('Goal achieved!')
        : this.$gettext('Goal not achieved yet')
    },
    isBeingAttached() {
      return (
          this.$taskCardsController.attachCandidatesIds &&
          this.task._id in this.$taskCardsController.attachCandidatesIds);
    },
    parentChipText() {
      const pKey = this.task.subtaskOf.parentKey
      if (pKey === defaultListID(this.$defaultDB))
        return false;

      const parent = this.$reactiveCache.docs[pKey];
      if (parent) {
        const maxLen = 24;
        return parent.name.length <= maxLen
          ? parent.name
          : parent.name.slice(0, maxLen) + '...';
      } else {
        return `unknown: ${this.task.subtaskOf.parentKey}`;
      }
    },
    categoryChipText() {
      const pKey = this.task.category.parentKey
      if (pKey === defaultListID(this.$defaultDB))
        return false;

      const parent = this.$reactiveCache.docs[pKey];
      if (parent) {
        const maxLen = 24;
        return parent.name.length <= maxLen
          ? parent.name
          : parent.name.slice(0, maxLen) + '...';
      } else {
        return `unknown: ${this.task.category.parentKey}`;
      }
    },
    statusChipText() {
      const pKey = this.task.status.parentKey
      if (pKey === defaultListID(this.$defaultDB))
        return false;

      const parent = this.$reactiveCache.docs[pKey];
      if (parent) {
        const maxLen = 24;
        return parent.name.length <= maxLen
          ? parent.name
          : parent.name.slice(0, maxLen) + '...';
      } else {
        return `unknown: ${this.task.status.parentKey}`;
      }
    },
    dateChipText() {
      const pf = this.task.plannedFor;
      return (pf.parentClass === 'list' && this.$reactiveCache.docs[pf.parentKey])
        ? this.$reactiveCache.docs[pf.parentKey].name
        : formatDateChip(pf, this.$gettext);
    },
    editMode() {
      return this.$taskCardsController.editModeTaskId === this.task._id;
    },
    undraggable() {
      return this.task.type === 'event'
          || this.$taskCardsController.selectedTasksIds && !this.selected
          || this.isBeingAttached
    },
    attachMode() {
      return !!this.$taskCardsController.attachCandidatesIds;
    },
    selectionMode() {
      return !!this.$taskCardsController.selectedTasksIds;
    },
    selected() {
      return (
          this.$taskCardsController.selectedTasksIds &&
          this.task._id in this.$taskCardsController.selectedTasksIds);
    },
    itemColor() {
      return calcItemColor(this.task, this.$reactiveCache);
    },
    localSpecialState() {
      return this.editMode || this.attachMode || this.selectionMode || this.dragInElements;
    },
    labels() {
      if (this.task.labels) {
        return this.task.labels
          .map(id => this.$reactiveCache.docs[id])
          .filter(doc => !!doc);
      } else {
        return [];
      }
    },
    assignees() {
      return (this.task.assignees || []).filter(user => this.task.couch.collaborators.includes(user))
    },
    parentMembers() {
      const ancestors = getReversedAncestors(this.task.cache, this.task)
        .map(rel => rel.subtaskOf)
        .map(pptr => pptr.parentKey)
        .map(id => this.$reactiveCache.docs[id])
      const combinedAssignees = [].concat.apply(
        [],
        ancestors.filter(item => !!item.assignees).map(item => item.assignees)
      );
      return combinedAssignees.filter(user => this.task.couch.collaborators.includes(user));
    },
  },
  watch: {
    editMode(enabled) {
      if (enabled) {
        this.$nextTick(() => {
          if (this.$refs.taskName) {
            this.$refs.taskName.focus();
          } else {
            console.error(`Error on focusing taskName for task "${this.task.name}"`)
            console.log(this.$refs)
          }
        });
      }
    },
    localSpecialState() {
      // Hover behavior depends on the special state. Re-evealuate
      // the hover status effects.
      if (this.$refs.hoverButtons) {
        if (this.hoverActive && !this.inSpecialState()) {
          this.$refs.hoverButtons.style.display = 'flex';
        } else {
          this.$refs.hoverButtons.style.display = 'none';
        }
      }
    },
  },
  mounted() {
    taskCardsMap.set(this.$el, this);
  },
  beforeDestroy() {
    taskCardsMap.delete(this.$el);
  },
};
